// src/main.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { checkForUpdate } from './utils/versionCheck';
import { isAppPlaying } from './utils/appState';

// Register service worker for offline support
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').then((registration) => {
    // Check for SW updates on every load so fixes roll out quickly
    registration.update().catch(() => {});
  }).catch((error) => {
    console.warn('Service Worker registration failed:', error);
  });

  // If a newer SW takes over, reload once so the page runs under it -
  // but never mid-session (a stale SW serving cached media was what broke
  // iOS playback; the update lands on the next visit otherwise).
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (isAppPlaying()) return;
    if (sessionStorage.getItem('swReloaded')) return;
    sessionStorage.setItem('swReloaded', '1');
    window.location.reload();
  });
}

// Reload with cleared caches if the server has a newer build
checkForUpdate();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
